import {
  faCoffee,
  faShieldHalved,
  faPoo,
  faPhone,
  faHippo,
  faBold,
  faRocket,
  faGift,
  faAnchor,
  faBug,
  faCar,
  faFlask,
  faFutbol,
  faHandSpock,
  faLiraSign,
  faMoon,
  faSnowflake,
  faSun,
} from '@fortawesome/free-solid-svg-icons';

const iconArr6x6 = [
  faCoffee,
  faShieldHalved,
  faPoo,
  faPhone,
  faHippo,
  faBold,
  faRocket,
  faGift,
  faAnchor,
  faBug,
  faCar,
  faFlask,
  faFutbol,
  faHandSpock,
  faLiraSign,
  faMoon,
  faSnowflake,
  faSun,
];
const iconArr4x4 = [
  faCoffee,
  faShieldHalved,
  faPoo,
  faPhone,
  faHippo,
  faBold,
  faRocket,
  faGift,
];

export { iconArr6x6, iconArr4x4 };
